module.exports = __webpack_public_path__ + "static/media/seminar-2.82a585fd.jpg";